<template>
  <div :class="[isMobile ? 'background-image-mobile' : 'background-image-desktop']">
    <div v-if="!isMobile" class="row" style="height:200px"></div>
    <div class="row justify-center">
      <img :class="[isMobile ? 'image-mobile' : 'image-desktop']" :src="image" alt />
    </div>
    <div class="row justify-center">
      <a
        :class="[
          isMobile ? 'gradient-button-mobile gradient-button-register' : 'gradient-button-desktop gradient-button-register'
        ]"
        @click="directToRegisterLink"
        >{{ $t('invitationPoster.registerNow') }}</a
      >
    </div>
  </div>
</template>
<script>
import { getterTypes } from '@/store/getter-types';
import { mapGetters } from 'vuex';
import tool from '@/common/js/tool.js';

export default {
  data() {
    return {
      image: '',
      currentLangCode: 'en_US',
      isMobile: false,
      inviteUrl: '',
      baseUrl: tool.getBaseUrl()
    };
  },
  methods: {
    checkIsMobileAndLang() {
      const currentLang = this.Getter_Lang;
      const queryString = this.$route.query;

      if (queryString && queryString.lang) {
        if (queryString.lang === 'zh_CN' || queryString.lang === 'zh_TW') {
          this.currentLangCode = queryString.lang;
        }
      } else if (currentLang) {
        if (currentLang.code === 'zh_CN' || currentLang.code === 'zh_TW') {
          this.currentLangCode = currentLang.code;
        }
      }

      this.isMobile = tool.browser().mobile;
      if (this.isMobile) {
        if (this.currentLangCode === 'zh_CN') {
          this.image = require('@/assets/images/invite-poster/Group 4263.png');
        } else if (this.currentLangCode === 'zh_TW') {
          this.image = require('@/assets/images/invite-poster/Group 4304.png');
        } else {
          this.image = require('@/assets/images/invite-poster/Group 4310.png');
        }
      } else {
        //not mobile
        if (this.currentLangCode === 'zh_CN') {
          this.image = require('@/assets/images/invite-poster/Group 4260.png');
        } else if (this.currentLangCode === 'zh_TW') {
          this.image = require('@/assets/images/invite-poster/Group 4294.png');
        } else {
          this.image = require('@/assets/images/invite-poster/Group 4306.png');
        }
      }
    },
    directToRegisterLink() {
      window.location = this.inviteUrl;
    },
    getMyReferralCode() {
      let inviteCode = this.$route.query.inviteCode;
      if (this.isUndefinedOrNullOrEmpty(inviteCode)) {
        return this.$router.push('/');
      }
      this.inviteUrl = this.baseUrl + '/register?inviteCode=' + inviteCode;
    }
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Lang])
  },
  mounted() {
    this.checkIsMobileAndLang();
    this.getMyReferralCode();
  }
};
</script>
<style lang="stylus" scoped>
.background-image-desktop {
  background-image: url('../../../assets/images/invite-poster/invitation-bg.jpg');
  background-size: cover;
  background-position: 50% center;
  min-height: 90vh;
  background-repeat: no-repeat;
}

.background-image-mobile {
  background-image: url('../../../assets/images/invite-poster/invitation-bg.jpg');
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
}

.image-desktop {
  width: 40%;
}

.image-mobile {
  max-width: 80%;
  margin-top: 12%;
}

.gradient-button-desktop {
  margin-top: 10px;
  font-family: 'Arial Black', Gadget, sans-serif;
  font-size: 80%;
  padding: 15px;
  text-align: center;
  background-size: 200% auto;
  color: #FFF;
  width: 125px;
  cursor: pointer;
  display: inline-block;
  border-radius: 25px;
}

.gradient-button-mobile {
  margin-top: 30px;
  font-family: 'Arial Black', Gadget, sans-serif;
  font-size: 100%;
  padding: 15px;
  text-align: center;
  background-size: 200% auto;
  color: #FFF;
  width: 50%;
  cursor: pointer;
  display: inline-block;
  border-radius: 25px;
}

.gradient-button-register {
  background-image: linear-gradient(286deg, #1E49AC 0%, #0090FA 100%);
}

@media screen and (max-width: 768px) {
  .image-mobile {
    max-width: 60%;
    margin-top: 12%;
  }
}

@media screen and (max-width: 767px) {
  .image-mobile {
    max-width: 80%;
    margin-top: 12%;
  }
}
</style>
